import React from "react"
import {SelectOneScreen} from "components/SelectOneScreen"

// Answer values are exported so the orchestrator can route:
//   No  -> Screen 4 (Medical Practitioner)
//   Yes -> Pathway 3 (records-first review gate, $99)
export const APPLICATION_STATUS_NO = "No"
export const APPLICATION_STATUS_YES_NEEDS_DOCTOR =
  "Yes, but I need a doctor to sign it"

const OPTIONS = [APPLICATION_STATUS_NO, APPLICATION_STATUS_YES_NEEDS_DOCTOR]

interface EligibilityApplicationStatusProps {
  value: string
  onSelect: (answer: string) => void
  onContinue: () => void
  onBack: () => void
}

// Screen 3 (NEW). Asks whether the applicant already has a prepared application.
export const EligibilityApplicationStatus: React.FC<
  EligibilityApplicationStatusProps
> = (props: EligibilityApplicationStatusProps) => {
  const {value, onSelect, onContinue, onBack} = props
  return (
    <SelectOneScreen
      heading="Have you already had your application prepared?"
      options={OPTIONS}
      value={value}
      onSelect={onSelect}
      onContinue={onContinue}
      onBack={onBack}
    />
  )
}

export default EligibilityApplicationStatus
